import axios from "axios";

const api = axios.create({
  baseURL: "http://38.165.46.98:8085/token-use-api/api",
  // baseURL: "http://192.168.31.109:8085/token-use-api/api",
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    // Authorization: "Bearer your-token-here", // 如果需要认证
  },
});

export default {
  // 查
  fetchList: (resource: any) => api.get(`/${resource}`),
  fetchListBody: (resource: any, data: any) => api.get(`/${resource}`, data),

  // 增
  createItem: (resource: any, data: any) => api.post(`/${resource}`, data),

  // 改
  updateItem: (resource: any, id: any, data: any) =>
    api.put(`/${resource}/${id}`, data),

  // 删
  deleteItem: (resource: any, id: any) => api.delete(`/${resource}/${id}`),
};
